import { ClockCounterClockwiseIcon, XIcon } from "@phosphor-icons/react";

/**
 * Anuncia que el formulario se relleno con un borrador anterior.
 *
 * Sin este aviso, el formulario aparece con datos que el usuario no acaba de
 * escribir y nada lo explica. En una app donde se publica informacion sobre
 * personas desaparecidas, publicar por descuido los datos de otra sesion es un
 * error caro: el reporte sale con informacion falsa.
 */
function AvisoBorrador({ onDescartar }) {
  return (
    <aside className="aviso-borrador" role="status">
      <ClockCounterClockwiseIcon weight="duotone" />
      <div>
        <strong>Retomamos un reporte sin terminar</strong>
        <p>Los campos traen lo que escribiste antes. Revísalos antes de publicar.</p>
      </div>
      <button type="button" onClick={onDescartar} title="Empezar de cero">
        <XIcon weight="bold" /> Empezar de cero
      </button>
    </aside>
  );
}

export default AvisoBorrador;
